/**
 * Phones: the top bar keeps only the company, Month, Cash and the big Next Month button. Fast Forward,
 * Sound, Save/Load and Feedback move into a small ⚙ button in the top-right corner (Rachit, 2026-10-20:
 * on a phone they took up half the screen). Each menu item presses the real button, so nothing is
 * duplicated. On a computer the ⚙ button is hidden by CSS and the top bar is unchanged.
 */
function gesBuildPhoneMenu() {
  const bar = document.querySelector("#dashboard-screen .topbar");
  if (!bar || document.getElementById("btn-settings")) return;
  const btn = document.createElement("button");
  btn.type = "button";
  btn.id = "btn-settings";
  btn.className = "btn-settings";
  btn.setAttribute("aria-label", "Settings and more");
  btn.setAttribute("aria-expanded", "false");
  btn.textContent = "⚙";
  const menu = document.createElement("div");
  menu.id = "settings-menu";
  menu.className = "settings-menu hidden";
  menu.setAttribute("role", "menu");
  menu.innerHTML = `
    <div class="sm-label">Fast forward</div>
    <div class="sm-ff">
      <button type="button" role="menuitem" data-sm-ff="3">3 months</button>
      <button type="button" role="menuitem" data-sm-ff="6">6 months</button>
      <button type="button" role="menuitem" data-sm-ff="12">12 months</button>
    </div>
    <button type="button" class="sm-item" role="menuitem" data-sm="sound">🔊 Sound</button>
    <button type="button" class="sm-item" role="menuitem" data-sm="save">💾 Save / Load</button>
    <button type="button" class="sm-item" role="menuitem" data-sm="feedback">💬 Feedback</button>
    <button type="button" class="sm-item" role="menuitem" data-sm="glossary">📖 Glossary</button>
    <button type="button" class="sm-item" role="menuitem" data-sm="account">👤 Account</button>
    <a class="sm-item sm-credit" role="menuitem" href="https://www.linkedin.com/in/rachit-singh-6439032b4" target="_blank" rel="noopener noreferrer">Created by <b>Rachit Singh</b></a>`;
  bar.appendChild(btn);
  document.body.appendChild(menu);

  const close = () => { menu.classList.add("hidden"); btn.setAttribute("aria-expanded", "false"); };
  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    const r = btn.getBoundingClientRect();
    menu.style.top = `${r.bottom + 6}px`;
    menu.style.right = `${Math.max(8, window.innerWidth - r.right)}px`;
    const opening = menu.classList.contains("hidden");
    menu.classList.toggle("hidden", !opening);
    btn.setAttribute("aria-expanded", String(opening));
  });
  menu.addEventListener("click", (e) => {
    e.stopPropagation();
    const ff = e.target.closest("[data-sm-ff]");
    const item = e.target.closest("[data-sm]");
    if (!ff && !item) return;
    close();
    if (ff) {
      const real = document.querySelector(`#ff-menu [data-ff="${ff.dataset.smFf}"]`);
      if (real) real.click();
      return;
    }
    if (item.dataset.sm === "account") {
      // the account / guest chip floats over the page on phones, so it's hidden there: open it from here
      const chip = document.getElementById("account-chip") || document.getElementById("guest-chip");
      if (chip) {
        chip.classList.add("sm-shown");
        const face = chip.querySelector(".ac-face") || chip.querySelector("button") || chip;
        face.click();
        setTimeout(() => document.addEventListener("click", () => chip.classList.remove("sm-shown"), { once: true }), 0);
      }
      return;
    }
    if (item.tagName === "A") return;
    const target = { sound: "btn-sound", save: "btn-save-load", feedback: "btn-feedback", glossary: "btn-glossary" }[item.dataset.sm];
    const real = document.getElementById(target);
    if (!real) return;
    real.click();
    if (item.dataset.sm === "sound") {
      // the sound panel places itself under its own (hidden) button: put it under the ⚙ instead
      const panel = document.querySelector(".au-panel");
      const r = btn.getBoundingClientRect();
      if (panel) { panel.style.top = `${r.bottom + 6}px`; panel.style.right = `${Math.max(8, window.innerWidth - r.right)}px`; }
    }
  });
  document.addEventListener("click", close);
  window.addEventListener("resize", close);
}

if (typeof window !== "undefined" && typeof document !== "undefined") {
  try { gesBuildPhoneMenu(); } catch (e) { /* the top bar still works without it */ }
}
